import * as R from 'ramda'
import { createSelector } from 'reselect'

import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => state.values
const layerCountPgmSelectorFunc = state => state.sources ? state.sources : []

const minLayerCountSelectorHoc = (layerCountPgmSelectorFunc) => (
  createSelector(
    entitiesSelector,
    layerCountPgmSelectorFunc,
    (entities, refs) => R.ifElse(
      R.length,
      R.compose(R.nth(0), R.map(({id, type}) => {
        const pgm = entities[type][id]
        return parseInt(pgm['min'])
      })),
      R.always(2) // default minimum layer count if not specified in pgm
    )(refs)
  )
)

const maxLayerCountSelectorHoc = (layerCountPgmSelectorFunc) => (
  createSelector(
    entitiesSelector,
    layerCountPgmSelectorFunc,
    (entities, refs) => R.ifElse(
      R.length,
      R.compose(R.nth(0), R.map(({id, type}) => {
        const pgm = entities[type][id]
        return parseInt(pgm['max'])
      })),
      R.always(24) // default maximum layer count if not specified in pgm
    )(refs)
  )
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesSelectorFunc)
  const minLayerCountSelector = minLayerCountSelectorHoc(withPath(layerCountPgmSelectorFunc))
  const maxLayerCountSelector = maxLayerCountSelectorHoc(withPath(layerCountPgmSelectorFunc))

  return {
    valuesSelector,
    labelSelector,
    minLayerCountSelector,
    maxLayerCountSelector
  }
}
